import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AppInsightsService {
	appInsights: ApplicationInsights;

	constructor() {
		this.appInsights = new ApplicationInsights({
			config: {
				instrumentationKey: environment.instrumentationKey,
				enableAutoRouteTracking: true, // option to log all route changes
				disableCookiesUsage: true,
			},
		});
		this.appInsights.loadAppInsights();
	}

	logPageView(name?: string, url?: string): void {
		// option to call manually
		this.appInsights.trackPageView({
			name: name,
			uri: url,
		});
	}

	logEvent(name: string, properties?: { [key: string]: any }): void {
		this.appInsights.trackEvent({ name: name }, properties);
	}

	logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
		this.appInsights.trackMetric({ name: name, average: average }, properties);
	}

	logException(exception: Error, severityLevel?: number): void {
		this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
	}

	logTrace(message: string, properties?: { [key: string]: any }): void {
		this.appInsights.trackTrace({ message: message }, properties);
	}
}
